import {rei} from "@/services/api"

class RegistrosAnterioresService {
  static storeRegistroAnterior (registro) {
    return rei.post(`registros-anteriores`, registro).then(res => res.data)
  }

  static deleteRegistroAnterior (registro_anterior_id) {
    return rei.delete(`registros-anteriores/${registro_anterior_id}`)
  }

  static updateRegistroAnterior (registro) {
    return rei.put(`registros-anteriores/${registro.registro_anterior_id}`, { ...registro }).then(res => res.data)
  }

  static busca (busca) {
    return rei.post(`busca/registros-anteriores`, busca).then(res => res.data)
  }
}

export default RegistrosAnterioresService
